import React from 'react';

interface DownloadIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const DownloadIcon: React.FC<DownloadIconProps> = ({ 
  width = 20, 
  height = 20, 
  color = "black" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M13.6083 9.49078L10.1375 12.5M10.1375 12.5L6.66663 9.49078M10.1375 12.5L10.1375 2.08337M2.5 14.5834V16.8138H17.5V14.5834" 
        stroke={color} 
        strokeWidth="1.3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadIcon;

